import React from "react";

const ActionButtons = ({ onApprove, onReject, showAllow = false, showApprove = false, onAllow }) => {
  return (
    <div className="flex flex-col space-y-2">
      {showAllow && (
        <button
          onClick={onAllow}
          className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded text-sm font-medium transition-colors shadow-sm w-full"
        >
          Allow
        </button>
      )}
      <div className="flex space-x-2">
        {showApprove && (
          <button
            onClick={onApprove}
            className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded text-sm font-medium transition-colors shadow-sm flex-1"
          >
            Approve
          </button>
        )}
        <button
          onClick={onReject}
          className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded text-sm font-medium transition-colors shadow-sm flex-1"
        >
          Reject
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;
